import { useSnackbar } from "notistack";
import { FC, useEffect, useState } from "react";

import { Button, Stack, TextField } from "@mui/material";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";

interface GetDatabasesResponse {
    data: GetDatabasesData;
    error: IError;
}
interface GetDatabasesData {
    databases: string[];
}

interface CreateDatabaseResponse {
    data: CreateDatabaseData;
    error: IError;
}
interface CreateDatabaseData {
    status: string;
}

interface CreateDatabaseRequest {
    database: string;
}

const DatabasePrefix: string = "AutoWorks";

interface CreateDatabaseProps {
    workflowNextStep?: (database: string) => void;
}

const CreateDatabase: FC<CreateDatabaseProps> = ({ workflowNextStep = null }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [companyName, setCompanyName] = useState<string>("");
    const [databaseName, setDatabaseName] = useState<string>(DatabasePrefix);

    const [isDatabaseValid, setIsDatabaseValid] = useState<boolean>(true);

    const [databases, setDatabases] = useState<string[]>([]);

    useEffect(() => {
        GetDatabases();
    }, []);

    const GetDatabases = async () => {
        try {
            const response: GetDatabasesResponse = await api.get("api/Admin/GetDatabases", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }
            ).json();

            if (response.error == null) {
                setDatabases(response.data.databases)
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    };

    function ChangedCompanyName(event: any) {
        var value = event.target.value;
        setCompanyName(value);

        const dbName = `${DatabasePrefix}${value}`;

        setDatabaseName(dbName);
        setIsDatabaseValid(!databases.includes(dbName));
    }

    const CreateClient = async () => {
        if (companyName === "") {
            enqueueSnackbar("Please recheck fields", { variant: "error" });
            return;
        }

        var body: CreateDatabaseRequest = {
            database: databaseName
        }

        try {
            const response: CreateDatabaseResponse = await api.post("api/Admin/CreateDatabase", {
                json: body,
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                enqueueSnackbar("Created!", { variant: "success" })

                // for workflow function to step passed
                if (workflowNextStep)
                    workflowNextStep(databaseName);

                // clear fields
                setCompanyName("");
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    const isFormValid = companyName !== "" && isDatabaseValid;

    return (
        <Stack>
            {/* Company name */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '150px' }}>Company name: </p>
                <TextField
                    value={companyName}
                    onChange={ChangedCompanyName}
                    sx={{ minWidth: 245 }}
                    size="small"
                    id="off"
                    error={!isDatabaseValid}
                    helperText={!isDatabaseValid ? "Database is already in use" : ""}
                    disabled={databases.length === 0} />
            </Stack>

            {/* Database name */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '150px' }}>Database name: </p>
                <p>{databaseName}</p>
            </Stack>


            <Button
                variant="outlined"
                onClick={() => CreateClient()}
                sx={{ width: '82px' }}
                disabled={!isFormValid}>
                Create
            </Button>
        </Stack>
    )
}

export default CreateDatabase;